import React from 'react';
import { Link } from 'react-router-dom';

// eslint-disable-next-line import/prefer-default-export
export const METADATA_SCORING_COLUMNS = (
  handleViewScroringDetails,
  formValues
) => [
  {
    Header: 'Group ID',
    accessor: 'groupID',
    className: 'notranslate'
  },
  {
    Header: 'Group Name',
    accessor: 'groupName',
    className: 'notranslate'
  },
  {
    Header: 'Has Sub Groups',
    accessor: 'hasSubGroups',
    className: 'notranslate'
  },
  {
    Header: 'Points Possible',
    accessor: 'pointsPossible',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },
  {
    Header: 'Min Points Req',
    accessor: 'minPointsReq',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },

  {
    Header: 'Earned Score',
    accessor: 'earnedScore',
    className: 'notranslate ymca-word-break ymca-ellipse'
  },
  {
    Header: 'Actions',
    accessor: 'isHidden',
    className: 'hide',
    Cell: v => (
      <div className="d-flex">
        <Link
          to={v}
          className="table-link"
          onClick={() => handleViewScroringDetails(v, formValues)}
        >
          View Sub Groups
        </Link>
      </div>
    )
  }
];
